$(document).ready(function() {
    $('.js-game-select').on('click', function(e) {
		$(this).find('.b-game-filters__options').toggleClass('show');
    });
    $('body').on('click', function(e) {
    	if (!((e.target).closest('.b-game-filters__select'))) {
    		$('.b-game-filters__options').removeClass('show');
    	}
    });
    $('.js-game-option').on('click', function() {
        var text = $(this).text();
        $('.js-game-option').removeClass('active')
    	$(this).addClass('active');
        $('.b-game-filters__select-text').text(text);
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-index/game-select.js